export default __webpack_public_path__ + "static/media/step-one.658bcc1b.png";